import { useContext } from 'react';

import CartContext from './Cart.context';

const useCart = () => {
  const { order, openCart, closeCart, isCartOpen, isCartRefactorEnabled } =
    useContext(CartContext);

  /**
   * Handle the logic for adding and removing items
   * from the cart
   *
   * const { mutate, isLoading: isAddingItem } = useMutation(addCartItem);
   * const { mutate, isLoading: isUpdatingItem } = useMutation(updateCartItem);
   * const { mutate, isLoading: isRemovingItem } = useMutation(removeCartItem);
   */

  const addItemToCart = () => {
    openCart();
  };

  return {
    order,
    addItemToCart,
    openCart,
    closeCart,
    isCartOpen,
    isCartRefactorEnabled,
  };
};

export default useCart;
